import React, { useState, useEffect } from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Alert } from '@mui/material';

const AutohideSnackbar = ({
  message,
  type,
  autoHideDuration,
  handleOnCloseSideEffect
}: {
  message: string;
  type: 'info' | 'error' | 'success' | 'warning';
  autoHideDuration?: number;
  handleOnCloseSideEffect?: () => void;
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setOpen(true);
    }
  }, [message]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    // if (reason === 'clickaway') {
    //   return;
    // }
    handleOnCloseSideEffect && handleOnCloseSideEffect();
    setOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={autoHideDuration ? autoHideDuration : 10000} onClose={handleClose} message={message}>
        <Alert onClose={handleClose} severity={type} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AutohideSnackbar;
